import React, { useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./styles/FilterHeader.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

function FilterHeader() {
  const { setMenu } = useContext(MenuContext);
  return (
    <div className="menu--header">
      <button className="menu--back" onClick={() => setMenu("closed")}>
        <ArrowBackIosNewIcon style={{ fill: "#ffffff" }} fontSize="large" />
      </button>
      <div className="menu--userDisplay">Admin</div>
      <button className="menu--user">
        <AccountCircleIcon style={{ fill: "#ffffff" }} fontSize="large" />
      </button>
    </div>
  );
}

export default FilterHeader;
